import React, { useEffect, useState } from 'react';
import './pendingApproval.scss';
import TableLayout from 'components/SharedLayout/TableLayout/tableLayout';
import DetailsLayout from 'components/SharedLayout/DetailsLayout/detailsLayout';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'Store/store';
import { getRiskDetails } from 'Action/statusDetailsAction';
import { getFEDSAReferenceNumber } from 'utils/common';
import { getEudrSubmissionResult } from 'Action/eudrSubmissionAction';
import Toast from '@ingka/toast';
import { getSaveForLaterAction } from 'Action/saveForLaterAction';
import { getInvalidateAction } from 'Action/invalidateAction';
import MultiSelect from 'components/SharedLayout/Multiselect/multiSelect';
import { getStatusList } from 'Action/statusDetailsAction';
const PendingApproval = ({
  queries,
  setQuery,
  tabChange,
  handleTabChange,
  submittedToEUTabRef,
  items,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const { pendingApprovalList, riskDetailList, saveForLaterList, invalidList } = useSelector(
    (state: RootState) => state.statusDetails
  );
  const [showDetailsData, setShowDetailsData] = useState(false);
  const [listData, setListData] = useState<any>([]);
  const [filteredData, setFilteredData] = useState<any>([]);
  const [riskDetailsById, setRiskDetailsById] = useState<any>([]);
  const [fedsaReference, setFEDSAReference] = useState<any>();
  const [ddsReference, setDDSReference] = useState<any>();
  const [invalidateData, setInvalidateData] = useState('Invalidate');
  const [savedForLater, setSavedForLater] = useState('SaveForLater');
  const [selectedPendingData, setSelectedPendingData] = useState(pendingApprovalList);
  const [toastOpen, setToastOpen] = useState<any>(false);
  const [toastMessage, setToastMessage] = useState('');
  const [comment, setComment] = useState('');
  const [craStatus, setCraStatus] = useState(true);
  const [glaStatus, setGlaStatus] = useState(true);
  const [acceptRiskChecked, setAcceptRiskChecked] = useState(false);
  const [autoApprove, setAutoApprove] = useState(false);
  const [multiSelectKey, setMultiSelectKey] = useState(0);
  const [noResponse, setNoResponse] = useState(false);
  const mapping = {
    isEntryFromAPI: 'Source',
    supplierName: 'Supplier Name',
    articles: 'Supplier Article Number / GTIN',
    goodsDescription: 'Trade Item Description',
    fedsa_RefNum: 'Ref_Num',
    receivedOn: 'DDS Received On',
    fedsaStatus: 'Current status',
    pdf: 'PDF',
  };
  const riskDetailMapping = {
    commodities: 'Commodities',
    country: 'Country',
    productionPlaceCount: 'Production Place',
    cra: 'CRA',
    gla: 'GLA',
  };

  const resetAcceptRiskChecked = () => {
    setAcceptRiskChecked(false);
  };

  const resetAutoApprove = () => {
    setAutoApprove(false);
  };

  useEffect(() => {
    let items = mappedItems(pendingApprovalList, mapping);
    if (queries.length === 0) {
      setListData(items);
      setNoResponse(false);
    } else {
      let filteredItems = items?.filter((item) => {
        return (
          item['Supplier Name']?.toLowerCase().includes(queries.toLowerCase()) ||
          item['Supplier Article Number / GTIN']?.toLowerCase().includes(queries.toLowerCase()) ||
          item['Ref_Num']?.toLowerCase().includes(queries.toLowerCase()) ||
          item['DDS Ref_Num']?.toLowerCase().includes(queries.toLowerCase())
        );
      });
      setListData(filteredItems);
      setFilteredData(true);
      setNoResponse(false);
    }
  }, [pendingApprovalList, queries]);

  useEffect(() => {
    let items = mappedItems(riskDetailList, riskDetailMapping);
    setRiskDetailsById(items);
    if (riskDetailList?.length > 0) {
      const craPassed = riskDetailList?.every((item) => item?.cra?.isPassed);
      const glaPassed = riskDetailList?.every((item) => item?.gla?.isPassed);
      setCraStatus(craPassed);
      setGlaStatus(glaPassed);
    }
  }, [riskDetailList]);
  useEffect(() => {
    setMultiSelectKey((prevKey) => prevKey + 1);
  }, [tabChange]);

  const mappedItems = (itemList, mappingKey) => {
    return itemList?.map((item) => {
      return Object.keys(mappingKey).reduce((acc, key) => {
        acc[mappingKey[key]] = item[key] !== undefined ? item[key] : null; // Set to null if the key does not exist
        return acc;
      }, {});
    });
  };

  const saveForLater = async (fedsaReference) => {
    if (fedsaReference) {
      setFEDSAReference(fedsaReference);
      setSavedForLater('SaveForLater');
      try {
        const response = await dispatch(
          getSaveForLaterAction({ id: fedsaReference, description: comment }, 'SaveForLater')
        );
        if (response && response?.status === 200) {
          setToastOpen(true);
          setToastMessage('Saved for later');
          setTimeout(() => {
            setToastOpen(false);
            window.location.reload();
          }, 2000);
        } else {
          setToastOpen(true);
          setToastMessage('Failed to save for later');
          return;
        }
      } catch (error) {
        setToastOpen(true);
        setToastMessage('error');
      }
    }
  };
  const onClose = () => {
    setToastOpen(false);
  };
  const submit = async () => {
    if (fedsaReference) {
      try {
        const response = await dispatch(getEudrSubmissionResult({ id: fedsaReference }));

        if (response && response?.status === 200) {
          setToastOpen(true);
          setToastMessage('Submission Success');
          setTimeout(() => {
            setToastOpen(false);
            if (submittedToEUTabRef.current) {
              submittedToEUTabRef.current.click();
            }
          }, 2000);
        } else {
          setToastOpen(true);
          setToastMessage('Submission failed');
          return;
        }
      } catch (error) {
        setToastOpen(true);
        setToastMessage('Submission failed');
      }
    }
  };

  const invalidate = async (fedsaReference) => {
    if (fedsaReference) {
      setFEDSAReference(fedsaReference);
      setSavedForLater('Invalidate');
      try {
        const response = await dispatch(
          getInvalidateAction({ id: fedsaReference, description: comment }, 'Invalidate')
        );
        if (response && response?.status === 200) {
          setToastOpen(true);
          setToastMessage('Invalidated');
          setTimeout(() => {
            setToastOpen(false);
            dispatch(getStatusList('Pending'));
          }, 2000);
        } else {
          setToastOpen(true);
          setToastMessage('Failed to invalidate');
          return;
        }
      } catch (error) {
        setToastOpen(true);
        setToastMessage('error');
      }
    }
  };

  const buttonData = [
    { label: 'Save for later', onClick: () => saveForLater(fedsaReference) },
    {
      label: 'Submit',
      onClick: submit,
      disabled: !craStatus || (!glaStatus && !acceptRiskChecked),
    },
    { label: 'Invalidate', onClick: () => invalidate(fedsaReference) },
  ];

  const onShowDetails = (value, fedsa_RefNum) => {
    if (fedsa_RefNum) {
      setFEDSAReference(fedsa_RefNum);
      const selectedRow = getFEDSAReferenceNumber(pendingApprovalList, fedsa_RefNum);
      setDDSReference(selectedRow.dds_RefNum);
      dispatch(getRiskDetails(selectedRow.fedsa_RefNum));
    }
    setShowDetailsData(value);
  };

  const onSearch = (searchQuery) => {
    setQuery(searchQuery);
  };
  const getFilterData = (data) => {
    const uniqueNames = Array.from(
      new Set(
        data.map((item: { [x: string]: any }) => item['supplierName']).filter((name: any) => name)
      )
    );

    return uniqueNames;
  };
  const comboFilter = (list) => {
    if (list?.length > 0) {
      let items = mappedItems(pendingApprovalList, mapping);
      let filteredItems = [];
      if (queries?.length > 0) {
        filteredItems = items?.filter((item) => {
          return (
            item['Supplier Name']?.toLowerCase().includes(queries.toLowerCase()) ||
            item['Supplier Article Number / GTIN']?.toLowerCase().includes(queries.toLowerCase()) ||
            item['Ref_Num']?.toLowerCase().includes(queries.toLowerCase()) ||
            item['DDS Ref_Num']?.toLowerCase().includes(queries.toLowerCase())
          );
        });

        if (filteredItems.length === 0) {
          setNoResponse(true);
        } else {
          setFilteredData(filteredItems);
          setNoResponse(false);
        }
      } else {
        filteredItems = items;
      }
      let data = filteredItems.filter((item) => {
        return list.includes(item['Supplier Name']);
      });
      if (data.length !== 0) {
        setListData(data);
        setNoResponse(false);
      }
    } else {
      return;
    }
  };

  return (
    <div className="details-container">
      <div className="table-container">
        <div className="table-list-view">
          {pendingApprovalList && listData?.length > 0 && (
            <div className="tablelayout">
              <div style={{ width: '25%' }}>
                <MultiSelect
                  key={multiSelectKey}
                  item={getFilterData(pendingApprovalList)}
                  comboFilter={comboFilter}
                  tabChange={tabChange}
                />
              </div>
              <TableLayout
                items={listData}
                isLeftSide={true}
                onShowDetails={onShowDetails}
                // pendingApprovalData={selectedPendingData}
                onSearch={onSearch}
                tabChange={tabChange}
                acceptRiskChecked={acceptRiskChecked}
                setAcceptRiskChecked={setAcceptRiskChecked}
                resetAcceptRiskChecked={resetAcceptRiskChecked}
                autoApprove={autoApprove}
                setAutoApprove={setAutoApprove}
                setComment={setComment}
                resetAutoApprove={resetAutoApprove}
              />
            </div>
          )}
          {noResponse && (
            <div className="no-response">
              <p>No response found</p>
            </div>
          )}
        </div>
      </div>
      {showDetailsData && riskDetailList?.length > 0 && riskDetailsById?.length > 0 && (
        <div className="detail-list">
          <DetailsLayout
            data={riskDetailsById}
            buttonData={buttonData}
            isCheckBoxDisable={false}
            isTextAreaDisbale={false}
            isDropdown={true}
            fedsaReference={fedsaReference}
            ddsReference={ddsReference}
            pendingApprovalData={pendingApprovalList}
            comment={comment}
            setComment={setComment}
            craStatus={craStatus}
            glaStatus={glaStatus}
            acceptRiskChecked={acceptRiskChecked}
            setAcceptRiskChecked={setAcceptRiskChecked}
            resetAcceptRiskChecked={resetAcceptRiskChecked}
            autoApprove={autoApprove}
            setAutoApprove={setAutoApprove}
            resetAutoApprove={resetAutoApprove}
          />
        </div>
      )}
      {toastOpen && (
        <Toast
          text={<strong>{toastMessage}</strong>}
          isOpen={toastOpen}
          actionClick={() => {}}
          onCloseRequest={onClose}
          ariaLabelCloseBtn="Dismiss notification"
        />
      )}
    </div>
  );
};

export default PendingApproval;
